import React, { Fragment, useState, useEffect, useContext } from 'react';
import Blog from '../../component/Section/Blog';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAllNews } from '../../core/services/news';
import { AppContext } from '../../core/Contexts/AppContext';
import ResponsivePagination from 'react-responsive-pagination';

const News = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  const initialPage = parseInt(searchParams.get('page')) || 1;

  const [news, setNews] = useState([]);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [page, setPage] = useState(initialPage);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [loading, setLoading] = useState(false);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, index) => currentYear - index);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };

  const { setTitle, setHeaderType, setImage } = useContext(AppContext);

  useEffect(() => {
    setTitle('სიახლეები');
    setImage('../../images/hero-images/news_hero.jpeg');
    setHeaderType(1);
  }, []);

  useEffect(() => {
    const query = {
      page,
      size: 9,
    };

    if (selectedMonth) query['month'] = selectedMonth;
    if (selectedYear) query['year'] = selectedYear;
    if (searchTerm) query['search'] = searchTerm;

    setLoading(true);
    getAllNews(query).then((result) => {
      const mappedNews = result.data.map((x) => ({
        id: x.news_id,
        date: x.tarigi_1,
        img: x.news_pic,
        title: x.title,
        desc: x.description,
      }));
      setNews(mappedNews);
      setTotalPageCount(result.total_pages);
      setLoading(false);
    });

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [page, selectedMonth, selectedYear, searchTerm]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set('page', page);
    navigate(`?${params.toString()}`, { replace: true });
  }, [page]);

  return (
    <Fragment>
      <div>
        <div className='container'>
          <div className='search-filter-container'>
            <input
              type='text'
              placeholder='სიახლეების ძებნა'
              value={searchTerm}
              onChange={handleSearchChange}
              className='search-input'
            />

            <div>
              <select
                value={selectedYear}
                onChange={handleYearChange}
                className='filter-select'
              >
                <option value=''>აირჩიე წელი</option>
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
              <select
                value={selectedMonth}
                onChange={handleMonthChange}
                className='filter-select'
              >
                <option value=''>აირჩიე თვე</option>
                <option value='1'>იანვარი</option>
                <option value='2'>თებერვალი</option>
                <option value='3'>მარტი</option>
                <option value='4'>აპრილი</option>
                <option value='5'>მაისი</option>
                <option value='6'>ივნისი</option>
                <option value='7'>ივლისი</option>
                <option value='8'>აგვისტო</option>
                <option value='9'>სექტემბერი</option>
                <option value='10'>ოქტომბერი</option>
                <option value='11'>ნოემბერი</option>
                <option value='12'>დეკემბერი</option>
              </select>
            </div>
          </div>
        </div>

        {loading && <div>იტვირთება</div>}
        {!loading && (
          <>
            <Blog blog={news} currentPath={location.pathname} />

            <div className='container'>
              <ResponsivePagination
                current={page}
                total={totalPageCount}
                onPageChange={setPage}
              />
            </div>
          </>
        )}
      </div>
    </Fragment>
  );
};

export default News;
